import { createContext, type ReactNode } from "react";
import type { LocalizedText } from "@/shared/api/types";

export interface LocalizedInputActionProps {
  /** The field's label (context for the action, e.g. a translation). */
  label: string;
  value: LocalizedText;
  onChange: (v: LocalizedText) => void;
  locales: readonly string[];
}

/**
 * An extra action shown next to every LocalizedInput's label (the app root
 * provides AI "Dịch tự động"); none by default, so the design system stays
 * free of business code.
 */
export const LocalizedInputActionContext = createContext<((props: LocalizedInputActionProps) => ReactNode) | null>(null);
